<template>
    <div v-if="table && view">

        <list-view v-if="view && view.view_type === 'list'" :table="table" :view="view"
                   :parent-table="parentTable" :parent-document="parentDocument"></list-view>
        <gallery-view v-if="view && view.view_type === 'gallery'" :table="table" :view="view"
                      :parent-table="parentTable" :parent-document="parentDocument"></gallery-view>
        <table-view v-if="view && view.view_type === 'table'" :table="table" :view="view"
                    :parent-table="parentTable" :parent-document="parentDocument"></table-view>
    </div>
</template>

<script>
    import ModelService from "../../services/ModelService";
    import ListView from "./ListView.vue";
    import GalleryView from "../gallery/GalleryView.vue";
    import TableView from "../table/TableView.vue";

    export default {
        name: 'LinkedObjectView',
        components: {TableView, GalleryView, ListView},
        props: ['childTableId', 'parentTable', 'parentDocument'],
        data() {
            return {
                model: webase.model,
                table: null,
                view: null
            }
        },
        mounted() {
            let service = new ModelService()
            service.get(this.childTableId).then((response) => {
                this.table = response
                this.view = this.table.views[0]
                console.log(this.table)
            }).catch((message) => {
                console.log('LinkedObjectView - error loading table')
                console.log(message)
            })
        }
    }
</script>

<style>

</style>
